import { c as _c } from "react/compiler-runtime";
import { Search, X } from 'lucide-react';
import { Button } from '@/components/common/button';
import { Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from '@/components/common/drawer';
import { FilterSectionContent } from '@/components/features/LocationSearch/FilterSection';
import type { ComponentProps } from 'react';
type FilterSectionContentProps = ComponentProps<typeof FilterSectionContent>;
interface MobileFilterDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filterSectionProps: FilterSectionContentProps;
  locationInputValue: string;
  onClearFilters: () => void;
  onOpenDrawer: () => void;
}
export function MobileFilterDrawer(t0) {
  const $ = _c(25);
  const {
    open,
    onOpenChange,
    filterSectionProps,
    locationInputValue,
    onClearFilters,
    onOpenDrawer
  } = t0;
  const t1 = locationInputValue || "City, Town, Postcode";
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="flex-1 text-lg text-blue-300">{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Search className="size-5 text-primary-blue shrink-0" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onOpenDrawer || $[4] !== t2) {
    t4 = <div className="bg-primary-green flex flex-col gap-5 py-10"><div className="mx-full max-w-7xl px-5"><Button onClick={onOpenDrawer} className="h-14 w-full rounded-xl bg-white flex flex-row items-center justify-between px-5 text-left hover:bg-white/90" variant="ghost">{t2}{t3}</Button></div></div>;
    $[3] = onOpenDrawer;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DrawerHeader className="border-b pb-4 shrink-0 sr-only"><DrawerTitle className="text-xl font-bold text-primary-blue">Filter Locations</DrawerTitle></DrawerHeader>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== filterSectionProps) {
    t6 = <div className="flex-1 min-h-0 overflow-y-auto px-5 py-6"><div className="mx-auto max-w-7xl"><FilterSectionContent {...filterSectionProps} inDrawer={true} /></div></div>;
    $[7] = filterSectionProps;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onClearFilters || $[10] !== onOpenChange) {
    t7 = () => {
      onClearFilters();
      onOpenChange(false);
    };
    $[9] = onClearFilters;
    $[10] = onOpenChange;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <X className="size-4" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <DrawerFooter className="border-t pt-4 shrink-0"><Button variant="outline" onClick={t7} className="w-full flex items-center justify-center gap-4">{t8}Clear all filters</Button></DrawerFooter>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <DrawerContent className="max-h-[90vh]! bg-primary-green flex flex-col">{t5}{t6}{t9}</DrawerContent>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onOpenChange || $[19] !== open || $[20] !== t10) {
    t11 = <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">{t10}</Drawer>;
    $[18] = onOpenChange;
    $[19] = open;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t4) {
    t12 = <>{t4}{t11}</>;
    $[22] = t11;
    $[23] = t4;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}